import {isLaterDate} from 'custom/dataReports/utils/functions';
import {PolicyTypes} from 'custom/newbiz/utils/constants';
import { formatDollar } from "./lookupFunctions";

function validateTermSection(formData, errors, user) {
  let chkFlag = false;
  let durationFlag = false;
  let totalFaceAmountFlag = false;
  let durationField = ""; //Duration field is stored so that the error is a field that is enabled and wrong.

  if (formData["chkTerm10"] || formData["chkTerm20"] || formData["chkTerm30"]) {
    chkFlag = true;
  }
  if (!chkFlag) {
    errors["chkTerm10"] = "At least one term product must be checked";
  }

  if (formData["chkTerm10"]) {
    if (
      formData["cboTermDurationType10"] === "A" &&
      +formData["txtTermDuration10"] === 85
    ) {
      durationFlag = true;
    } else if (
      formData["cboTermDurationType10"] === "Y" &&
      +formData["txtTermDuration10"] === 85 - +formData["txtAge"]
    ) {
      durationFlag = true;
    } else {
      durationField = "txtTermDuration10";
    }
  }
  if (formData["chkTerm20"] && !durationFlag) {
    if (
      formData["cboTermDurationType20"] === "A" &&
      +formData["txtTermDuration20"] === 85
    ) {
      durationFlag = true;
    } else if (
      formData["cboTermDurationType20"] === "Y" &&
      +formData["txtTermDuration20"] === 85 - +formData["txtAge"]
    ) {
      durationFlag = true;
    } else {
      durationField = "txtTermDuration20";
    }
  }
  if (formData["chkTerm30"] && !durationFlag) {
    if (
      formData["cboTermDurationType30"] === "A" &&
      +formData["txtTermDuration30"] === 85
    ) {
      durationFlag = true;
    } else if (
      formData["cboTermDurationType30"] === "Y" &&
      +formData["txtTermDuration30"] === 85 - +formData["txtAge"]
    ) {
      durationFlag = true;
    } else {
      durationField = "txtTermDuration30";
    }
  }
  if (!durationFlag && chkFlag) {
    errors[durationField] =
      "At least one term product must have a duration to age 85";
  }

  let maxTotal = 5000000;
  if (
    user?.permissions["isHeadOfficeOverride"]?.isActive === true &&
    user?.overrides["chkOverrideUseMaxFace"] === "true"
  ) {
    maxTotal = Math.max(+user?.overrides["txtOverrideMaxFace"], maxTotal);
  }
  if (+formData["txtTotalFaceAmount"] > maxTotal) {
    totalFaceAmountFlag = true;
  }
  if (totalFaceAmountFlag) {
    errors[
      "txtTotalFaceAmount"
    ] = `The total face amount cannot exceed ${formatDollar(maxTotal)}`;
  }
}

export default function ValidateForm(formData, rules, user) {
  //console.log("Inside ValidateForm");
  let errors = {};
  console.log(formData);
  if (formData["cboProduct"] === "0180") {
    validateTermSection(formData, errors, user);
  }

  if (
    formData["rdoPostalOrCity"] === "Postal" &&
    formData["txtPostalCode"] === ""
  ) {
    errors["txtPostalCode"] = "Postal Code cannot be empty";
  }
  if (formData["rdoPostalOrCity"] === "City" && formData["txtCity"] === "") {
    errors["City"] = "City cannot be empty";
  }

  // if (formData.chkBirthday === true || formData.rdoRange === "Date") {
  //   // if (!isLaterDate(formData.dtToDate, formData.dtFromDate)) {
  //   if (formData.dtToDate.getTime() < formData.dtFromDate.getTime()) {
  //     errors.push("'From' date must be less or equal to 'To' date");
  //   }
  // } else
  if (formData["chkBirthday"] === false || formData["rdoRange"] === "Age") {
  } else if (
    formData["dtToDate"] !== undefined &&
    formData["dtFromDate"] !== undefined
  ) {
    // if (!isLaterDate(formData.dtToDate, formData.dtFromDate)) {
    if (formData["dtToDate"].getTime() < formData["dtFromDate"].getTime()) {
      errors["dtFromDate"] = "'From' date must be less or equal to 'To' date";
    }
  }

  //New Rule Aug 2021 - If the insured is an adult and the owner name is blank then copy the insured name into the owner name field
  if (formData["txtOwnerName"] === "" && formData["txtInsuredName"] === "") {
    console.log("custom Form Validation error");
    errors["txtOwnerName"] =
      "You must enter the name of the policy owner and the insured before you can generate the illustration report.";
  } else if (formData["txtOwnerName"] === "") {
    if (parseInt(formData["txtAge"]) < 18) {
      console.log("custom Form Validation error");
      errors["txtOwnerName"] =
        "You must enter the name of the policy owner and the insured before you can generate the illustration report.";
    } else {
      formData["txtOwnerName"] = formData["txtInsuredName"];
    }
  } else if (formData["txtInsuredName"] === "") {
    console.log("custom Form Validation error");
    errors["txtInsuredName"] =
      "You must enter the name of the policy owner and the insured before you can generate the illustration report.";
  } else if (
    formData["cboPolicyType"] !== PolicyTypes.SINGLE &&
    formData["txtInsuredName2"] === ""
  ) {
    console.log("custom Form Validation error");
    errors["txtInsuredName2"] =
      "You must enter the name of all insureds before you can generate the illustration report.";
  }

  if (formData["formName"] === "eApplication") {
    if (!formData["chkPaymentDeclaration"]) {
      errors["chkPaymentDeclaration"] = "You must check payment declaration";
    }
    if (!formData["chkDeclarationAuthorization"]) {
      errors["chkDeclarationAuthorization"] =
        "You must check declaration and authorization";
    }
    if (
      formData["txtInsuredHomePhone"].length !==
      rules["txtInsuredHomePhone"].maxLength
    ) {
      errors["txtInsuredHomePhone"] =
        "You must enter valid Insured Home Phone Number";
    }
    if (
      formData["txtInsuredCellPhone"].length !==
      rules["txtInsuredCellPhone"].maxLength
    ) {
      errors["txtInsuredCellPhone"] =
        "You must enter valid Insured Cell Phone Number";
    }
    if (
      formData["txtInsuredPostalZipCode"].length !==
      rules["txtInsuredPostalZipCode"].maxLength
    ) {
      errors["txtInsuredPostalZipCode"] =
        "You must enter valid postal/zip code";
    }
    if (formData["rdoOwnerType"] !== "C") {
      if (
        formData["txtOwnerHomePhone"].length !==
        rules["txtOwnerHomePhone"].maxLength
      ) {
        errors["txtOwnerHomePhone"] =
          "You must enter valid Owner Home phone number";
      }
      if (
        formData["txtOwnerCellPhone"].length !==
        rules["txtOwnerCellPhone"].maxLength
      ) {
        errors["txtOwnerCellPhone"] =
          "You must enter valid Owner Cell phone number";
      }
      if (formData["txtOwnerSIN"].length !== rules["txtOwnerSIN"].maxLength) {
        errors["txtOwnerSIN"] = "You must enter valid SIN number";
      }
    }

    if (formData["rdoOwnerType"] === "C") {
      if (
        formData["txtBusinessNumber"].length !==
        rules["txtBusinessNumber"].maxLength
      ) {
        errors["txtBusinessNumber"] = "You must enter valid Business Number";
      }
      if (
        formData["txtBusinessPhone"].length !==
        rules["txtBusinessPhone"].maxLength
      ) {
        errors["txtBusinessPhone"] =
          "You must enter valid Business Phone Number";
      }
      if (
        formData["txtOwnerPostalZipCode"].length !==
        rules["txtOwnerPostalZipCode"].maxLength
      ) {
        errors["txtOwnerPostalZipCode"] =
          "You must enter valid postal/zip code for Owner";
      }
    }

    if (
      formData["rdoPaymentFrequency"] === "M" &&
      formData["rdoAccountType"] === "B"
    ) {
      if (
        formData["txtTransitNumber"].length !==
        rules["txtTransitNumber"].maxLength
      ) {
        errors["txtTransitNumber"] = "You must enter valid Transit Number";
      }
      if (
        formData["txtInstitutionNumber"].length !==
        rules["txtInstitutionNumber"].maxLength
      ) {
        errors["txtInstitutionNumber"] =
          "You must enter valid Institution Number";
      }
      if (
        formData["txtAccountNumber"].length !==
        rules["txtAccountNumber"].maxLength
      ) {
        errors["txtAccountNumber"] = "You must enter valid Account Number";
      }
    }
    if (
      formData["rdoWeightLoss"] === "Y" &&
      (!formData["txtWeightLoss"] ||
        formData["txtWeightLoss"].trim().length === 0)
    ) {
      errors["txtWeightLoss"] = "Please enter reason for weight loss";
    }

    if (
      formData["rdo2aCrimeQuestion"] === "Y" &&
      (!formData["txt2aCrimeDetails"] ||
        formData["txt2aCrimeDetails"].trim().length === 0)
    ) {
      errors["txt2aCrimeDetails"] =
        "Please enter asked details for Health Questions";
    }
    if (
      formData["rdo2bCrimeQuestion"] === "Y" &&
      (!formData["txt2bCrimeDetails"] ||
        formData["txt2bCrimeDetails"].trim().length === 0)
    ) {
      errors["txt2bCrimeDetails"] =
        "Please enter asked details for Health Questions";
    }
    // if (formData['rdo2cCrimeQuestion'] === 'Y' && (!formData['txt2cCrimeDetails'] || formData['txt2cCrimeDetails'].trim().length === 0)) {
    //   errors['txt2cCrimeDetails'] = 'Please enter asked details for Health Questions';
    // }
    if (
      formData["rdo3aValidateSymptom"] === "Y" &&
      (!formData["txt3aIllnessNature"] ||
        formData["txt3aIllnessNature"].trim().length === 0)
    ) {
      errors["txt3aIllnessNature"] = "You must provide nature of illness";
    }
    if (
      formData["rdo3bValidateSymptom"] === "Y" &&
      (!formData["txt3bIllnessNature"] ||
        formData["txt3bIllnessNature"].trim().length === 0)
    ) {
      errors["txt3bIllnessNature"] = "You must provide nature of illness";
    }
    if (
      formData["rdo3cValidateSymptom"] === "Y" &&
      (!formData["txt3cIllnessNature"] ||
        formData["txt3cIllnessNature"].trim().length === 0)
    ) {
      errors["txt3cIllnessNature"] = "You must provide nature of illness";
    }
  }
  /*
    if (!formData.email.toLowerCase().startsWith(formData.name.toLowerCase())) {
        errors.push("Email address must start with name");
    }
    */
  return errors;
}
